var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6466 22.58H0V0H23.6466V22.58Z",
    fill: "#5B2D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45264 16.6071L6.86571 14.0473L8.60385 15.3114L15.4932 10.2155L18.053 12.1196L19.7832 10.8555V16.6071H3.45264Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49424 5.60947C7.76624 5.60947 8.79332 6.57334 8.79332 7.75844C8.79332 8.94353 7.76624 9.90741 6.49424 9.90741C5.22224 9.90741 4.18726 8.94353 4.18726 7.75844C4.18726 6.57334 5.22224 5.60947 6.49424 5.60947Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.bc6050f0aa5750c4da760abe6fcd2043.svg";
export { ForwardRef as ReactComponent };